export { default, type LinkProps } from './Link';
